import React from 'react';

const KeySquare = (props: object) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      {...props}
    >
      <g clipPath="url(#clip0_4418_7096)">
        <path
          d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z"
          fill="white"
          style={{ fill: 'var(--fillg)' }}
        />
        <path
          d="M8.80999 18.2503C8.73999 18.2503 8.65999 18.2503 8.58999 18.2303L7.39999 18.0703C6.67999 17.9703 6.04999 17.3503 5.93999 16.6103L5.76999 15.4003C5.69999 14.9203 5.89999 14.3103 6.24999 13.9503L8.52999 11.6703C8.18999 10.0503 8.67999 8.37031 9.86999 7.19031C11.78 5.28031 14.9 5.28031 16.81 7.19031C17.74 8.12031 18.25 9.35031 18.25 10.6603C18.25 11.9703 17.74 13.2103 16.81 14.1303C15.62 15.3103 13.94 15.8003 12.33 15.4603L10.04 17.7403C9.74999 18.0503 9.25999 18.2503 8.80999 18.2503ZM13.34 7.25031C12.47 7.25031 11.59 7.58031 10.93 8.25031C10.03 9.15031 9.70999 10.4603 10.08 11.6803C10.16 11.9503 10.09 12.2303 9.88999 12.4303L7.30999 15.0103C7.28999 15.0403 7.24999 15.1503 7.24999 15.1903L7.41999 16.3903C7.42999 16.4503 7.53999 16.5603 7.59999 16.5703L8.79999 16.7403C8.84999 16.7303 8.94999 16.7103 8.97999 16.6803L11.57 14.0903C11.77 13.8903 12.06 13.8303 12.32 13.9103C13.53 14.2903 14.84 13.9703 15.74 13.0703C16.38 12.4303 16.74 11.5703 16.74 10.6603C16.74 9.75031 16.39 8.89031 15.74 8.25031C15.09 7.59031 14.21 7.25031 13.34 7.25031Z"
          fill="white"
          style={{ fill: 'var(--fillg)' }}
        />
        <path
          d="M10.45 17.0294C10.26 17.0294 10.07 16.9594 9.92003 16.8094L9.06003 15.9494C8.77003 15.6594 8.77003 15.1794 9.06003 14.8894C9.35003 14.5994 9.83003 14.5994 10.12 14.8894L10.98 15.7494C11.27 16.0394 11.27 16.5194 10.98 16.8094C10.84 16.9594 10.65 17.0294 10.45 17.0294Z"
          fill="white"
          style={{ fill: 'var(--fillg)' }}
        />
        <path
          d="M13.3801 11.7996C13.2401 11.7996 13.1101 11.7796 12.9901 11.7296C12.8701 11.6796 12.7601 11.5996 12.6701 11.5096C12.4801 11.3196 12.3701 11.0696 12.3701 10.7996C12.3701 10.5396 12.4801 10.2796 12.6701 10.0996C12.9001 9.85963 13.2501 9.74963 13.5701 9.81963C13.6301 9.83963 13.7001 9.84963 13.7601 9.87963C13.8201 9.90963 13.8801 9.93963 13.9301 9.96963C13.9801 10.0096 14.0401 10.0496 14.0801 10.0996C14.2701 10.2796 14.3801 10.5396 14.3801 10.7996C14.3801 10.9396 14.3501 11.0596 14.3001 11.1896C14.2501 11.3096 14.1801 11.4196 14.0801 11.5096C13.8901 11.6996 13.6401 11.7996 13.3801 11.7996Z"
          fill="white"
          style={{ fill: 'var(--fillg)' }}
        />
      </g>
      <defs>
        <clipPath id="clip0_4418_7096">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default KeySquare;
